import React from 'react';

export const TabsContext = React.createContext(0);
